import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  count?: number[];
  day: LangType[];
}

export const useTasksByWeekday = (): ChartProps => {
  const { t, getLocale } = useLang();
  const { list } = useDashboardStore();
  const data = list?.tasks_daily_load as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data?.count) {
      const isDataExist = data.count.some((count) => count > 0);

      return {
        series: isDataExist
          ? [
              {
                name: t('Кол-во задач'),
                data: data.count,
              },
            ]
          : [],
        options: {
          chart: {
            type: 'bar',
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '50%',
              borderRadius: 6,
              borderRadiusApplication: 'around',
              dataLabels: {
                position: 'top',
              },
            },
          },
          xaxis: {
            categories: data.day.map((day) => getLocale(day)),
            axisTicks: { show: false },
          },
          colors: ['#962DFF'],
          yaxis: {},
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
            shared: true,
            intersect: false,
            hideEmptySeries: true,
          },
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t]);

  return {
    series: chartData.series,
    options: chartData.options,
    type: 'bar',
    label: 'Дни недели с максимальной загрузкой',
    subLabel:
      'Диаграмма показывает, в какие дни недели (или часы) создаётся больше всего задач, что помогает лучше распределять рабочую нагрузку по календарю, или во времени',
    wrapped: true,
  };
};
